<template>
  <div class="psa__card-column">
    <photo-card
      v-for="photo in photos"
      :key="photo.id"
      v-on="$listeners"
      v-bind:requiresApproval="requiresApproval"
      v-bind:canManage="canManage"
      v-bind:photo="photo"
      v-bind:eventAttendee="eventAttendee"
      v-bind:apiAuthToken="apiAuthToken"
      v-bind:eventId="eventId"
      v-bind:streamId="streamId"
      v-bind:base-url="baseUrl"
      v-bind:is-web="isWeb"
      v-bind:subheader-one="subheaderOne"
      v-bind:subheader-two="subheaderTwo"
    >
    </photo-card>
  </div>
</template>

<script>
export default {
  props: [
    "eventId",
    "streamId",
    "manage",
    "apiAuthToken",
    "photos",
    "eventAttendee",
    "canManage",
    "requiresApproval",
    "baseUrl",
    "isWeb",
    "subheaderOne",
    "subheaderTwo",
  ],
  mounted: function() {
    this.$emit("column-resize")
  }
};
</script>

<style scoped>
.psa__card-column {
  flex: calc(33% - 7px);
}
</style>
